<ng-container *ngIf="diffusion$ | async as diffusion"></ng-container>
